export const NonTechEvents = {

    // House Full
    "house-full": {
        name: "House Full",
        refName: "house-full",
        about: `Are you looking for a bizarre event that furnishes a crazy time?. Then get ready and jump in. This is an event for all the non technical pros out there.`,
        fee: `Registration Fee - RS.150`,
        dateTime: [
             "Date:March 26th",
            "Time:6pm"
        ],

        contact: [
            {
                name: "Guru Naveen K",
                mobile: "6383357656"
            },
            {
                name: "Muralikrishnan S",
                mobile: "9092432578"
            },
            {
                name: "Surya N",
                mobile: "9500372299"
            }
        ],

        rules: [
            "This event is for individual participant only",
            "Member involved in any kind of malpractice will be disqualified immediately",
            "Decisions made by the administrators will be final",
            "Participants must ensure that they have laptop with good internet connectivity for their convenience",
            "Participants must ensure that they have microsoft account",
            "The winners will get exciting cash prizes, internship opportunities, T shirts and many more goodies"
        ],

        rounds: {
            number: 2,
            roundDetails: [
                {
                    title: "Prelims",
                    description: "Participants will be given 30 minutes to answer questions from familiar topics."
                },
                {
                    title: "Finals",
                    description: "A round in round robin fashion. Based on Kollywood (60 minutes)"
                },
            ]
        },
        registration: true,
        purpose: "EVENTS"
    },

    // Imagenation
    "imagenation": {
        name: "Imagenation",
        refName: "imagenation",
        about: `Hello Photographers, get your cam ready and start capturing the moment.
                Abacus’21 brings you the online photography contest.
                It is a social media based (Instagram) event where the contestant competes to
                showcase their photography talent. The photos will be displayed in the abacus 
                official social media handle`,
        fee: `Registration Fee - RS.150`,

        dateTime: [
            "Last Date - 20 March 2021",
            "Instagram - abacus21_ceg"
        ],

        contact: [
            {
                name: "Ritika M",
                mobile: "7538825268"
            },
            {
                name: "Preeth G",
                mobile: "9087449366"
            }
        ],

        theme: "Vintage Photography!",

        rules: [
            "Only one entry is allowed per contestant",
            "The photograph must be originally taken by the contestant. The photo must not contain any watermark or copyrights.",
            "The judge’s decisions are final based on the number of likes, shares, and creativity.",
            "Submissions will be not accepted once the deadline lapses.",
            "Photos which portray out of the theme mentioned or having vulgar content will be disqualified.",
            "In case of plagiarism or any kind of malpractice, the contestant will be disqualified.",
            "The winners will get exciting cash prizes, internship opportunities, T shirts and many more goodies"
        ],

        instructions: [
            "The contestant must enclose the photo along with the personal details in the format:",
            "Name",
            "Year",
            "Department",
            "College",
            "Email Id : events@abacus.org.in (tentative)",
            "Last date for sending the photo: 20-03-2021",
            "Send your entries to (email id) : abacus.imagenation@gmail.com"
        ],
        registration: false
    },

    // Graphic Traffic
    "graphic-traffic": {
        name: "Graphic Traffic",
        refName: "graphic-traffic",
        about: `Hello Designers, get your sketch ready and start portraying the moment.
                Abacus’21 brings you the online poster designing contest.
                It is a social media based (Instagram) event where the contestant competes 
                to showcase their designing talent. The posters will be displayed in the abacus 
                official social media handle.`,
        fee: `Registration Fee - RS.150`,
        dateTime: [
            "Last Date - 20 March 2021",
            "Instagram - abacus21_ceg"
        ],

        contact: [
            {
                name: "Adhithya K",
                mobile: "8883018311"
            },
            {
                name: "Usha Varshini Saravanan",
                mobile: "9894560778"
            }
        ],

        theme: "Before, during and after lockdown",

        rules: [
            "Only one entry is allowed per contestant",
            "The poster must be originally designed by the contestant",
            "The judge’s decisions are final based on the number of likes, shares, and creativity",
            "Submissions will be not accepted once the deadline lapses",
            "Posters which portray out of the theme mentioned or having vulgar content will be disqualified",
            "In case of plagiarism or any kind of malpractice, the contestant will be disqualified",
            "The winners will get exciting cash prizes, internship opportunities, T shirts and many more goodies"
        ],

        instructions: [
            "The contestant must enclose the poster along with the personal details in the format:",
            "Name",
            "Year",
            "Department",
            "College",
            "Email Id : events@abacus.org.in (tentative)",
            "Last date for sending the poster: 20-03-2021",
            "Send your entries to (email id) : abacus.graphictraffic@gmail.com"
        ],
        /* rounds: {
            number: 2,
            roundDetails: [
                {
                    title: "Prelims",
                    description: "Participants will be given 30 minutes to answer questions from familiar topics."
                },
                {
                    title: "Finals",
                    description: "A round in round robin fashion. Based on Kollywood (60 minutes)"
                },
            ]
        }, */
        registration: false
    },
}